import React from "react";
import { Fa } from "../../atoms/Icons/Fa";
import { Text } from "../../atoms/Text/Text";
import { FriendTabs } from "../../services/Friend/FriendService";
import styles from "./FriendContainer.css";

type RenderFooterProps = {
  tabId: FriendTabs;
  onClickSeeButton: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
};

export class RenderFooter extends React.Component<RenderFooterProps> {
  render() {
    const { tabId } = this.props;
    const attributes = { align: "center" };

    return (
      <tfoot {...attributes} className={styles.tfooter}>
        <tr>
          <td colSpan={2}>
            <SeeButton align="center" onClick={this.props.onClickSeeButton}>
              <Text bold={true} size="sm" style={{ padding: "5px" }}>
                {tabId === FriendTabs.OrderByDateAll ||
                tabId === FriendTabs.OrderByFriendAll
                  ? "See Less"
                  : "See More"}
              </Text>

              <div className={styles.triggerSeeBlock}>
                {tabId === FriendTabs.OrderByDateAll ||
                tabId === FriendTabs.OrderByFriendAll ? (
                  <Text key="opened" className={styles.openButton}>
                    <Fa className={styles.openButtonSeeIcon} icon="angle-up" />
                  </Text>
                ) : (
                  <Text key="closed" className={styles.openButton}>
                    <Fa
                      className={styles.openButtonSeeIcon}
                      icon="angle-down"
                    />
                  </Text>
                )}
              </div>
            </SeeButton>
          </td>
        </tr>
      </tfoot>
    );
  }
}

const SeeButton = (props: any) => (
  <button className={styles.seeButton} {...props} />
);
